import { Empty } from "antd-mobile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { newsApi } from "../../../../api/news-api";
import { getText } from "../../../../utils/util";
import "./index.css";

export default function CenterPage({ hyorders }) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const lan = localStorage.getItem("i18n");

  // const getNode = () => {
  //   const nodes = [];
  //   for (let index = 0; index < hyorders.length; index++) {
  //     const data = hyorders[index];
  //     const node = (
  //       <div
  //         className="jyjl-9"
  //         onClick={() => {
  //           const sendData = {
  //             orderNo: data.orderNo,
  //             coinname: data.coinname,
  //             num: data.num,
  //             ploss: data.ploss,
  //             buytime: data.buytime,
  //             status: data.status,
  //             isWin: data.isWin,
  //           };
  //           navigate(
  //             `/marketOrderInfo/${data.id}?data=${JSON.stringify(sendData)}`
  //           );
  //         }}
  //       >
  //         <div className="jyjl-10">
  //           <div className="jyjl-11">
  //             <div className="jyjl-12">
  //               <div className="jyjl-13">{data.num.toFixed(4)}</div>
  //               <div className="jyjl-14">{translate(getText("期權"))}</div>
  //               <div className="jyjl-15">{data.buytime?.substring(0, 16)}</div>
  //             </div>
  //             <span className="jyjl-16">
  //               {data?.status === 2
  //                 ? translate(getText("已完成"))
  //                 : translate(getText("到期結算"))}
  //             </span>
  //             <span className="jyjl-17">
  //               <span className="jyjl-18">{translate(getText("詳情"))}</span>
  //             </span>
  //           </div>
  //         </div>
  //       </div>
  //     );
  //     nodes.push(node);
  //   }
  //   return nodes;
  // };

  const getNode = () => {
    const nodes = [];
    for (let index = 0; index < hyorders.length; index++) {
      const data = hyorders[index];
      const node = (
        <li
          key={data.id}
          className="mb-3 rounded-lg bg-neutral-800 overflow-hidden border border-neutral-700 shadow-md transition-all duration-300 hover:shadow-lg"
          onClick={() => {
            const sendData = {
              orderNo: data.orderNo,
              coinname: data.coinname,
              num: data.num,
              ploss: data.ploss,
              buytime: data.buytime,
              status: data.status,
              isWin: data.isWin,
            };
            if (data.status == 1) {
              return;
            }
            navigate(
              `/marketOrderInfo/${data.id}?data=${JSON.stringify(sendData)}`
            );
          }}
        >
          <div className="p-4">
            {/* 头部信息 */}
            <div className="flex justify-between items-center mb-3">
              <div className="flex items-center">
                <div className="font-medium text-white">
                  {data.coinname}
                  <span className={`ml-2 px-2 py-0.5 text-xs rounded-full ${data.hyzd == 1 ? 'bg-success/20 text-success' : 'bg-danger/20 text-danger'}`}>
                    {data.hyzd == 1
                      ? translate(getText("看漲"))
                      : translate(getText("看跌"))}
                  </span>
                </div>
              </div>
              <div className="text-xs text-neutral-400">{data.buytime?.substring(0, 16)}</div>
            </div>
            
            {/* 数量和盈亏 */}
            <div className="flex justify-between items-center mb-4">
              <div>
                <span className="text-xl text-white font-semibold">
                  {data.num.toFixed(2)}
                  <span className="ml-1 text-xs text-neutral-400">USDT</span>
                </span>
              </div>
              <div className="flex items-center">
                <span className="text-neutral-400 mr-1">{translate(getText("盈虧"))}</span>
                {data.status != 1 && (
                  <span className={`font-medium ${data.isWin == 1 ? 'text-success' : 'text-danger'}`}>
                    {data.isWin == 1 ? "+" : "-"}
                    {Math.abs(data.ploss)}
                  </span>
                )}
              </div>
            </div>
            
            {/* 分隔线 */}
            <div className="h-px bg-neutral-700 my-3"></div>
            
            {/* 底部详情 */}
            <div className="grid grid-cols-3 gap-2 text-xs">
              <div>
                <div className="text-neutral-400 mb-1">
                  {translate(getText("購買"))}
                  {lan == "zh" ? "" : <span>&nbsp;</span>}
                  {translate(getText("價格"))}
                </div>
                <div className="text-white">{data.buyprice}</div>
              </div>
              <div>
                <div className="text-neutral-400 mb-1">
                  {translate(getText("結算價格"))}
                </div>
                <div className="text-white">{data.sellprice}</div>
              </div>
              <div>
                <div className="text-neutral-400 mb-1">{translate(getText("周期"))}</div>
                <div className="text-white">{data.time}</div>
              </div>
            </div>
          </div>
        </li>
      );
      nodes.push(node);
    }
    return nodes;
  };
  return (
    <div className="container mx-auto">
      <ul className="space-y-3">{getNode()}</ul>
      <div className="text-neutral-400 text-center py-4 text-sm">{translate(getText("暂无更多了"))}</div>
    </div>
  );
}
